import { render } from "./VienneseView.vue?vue&type=template&id=3c7fcbef"
import script from "./VienneseView.vue?vue&type=script&lang=js"
export * from "./VienneseView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__